import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Product } from '../../models/product';
import { ProductsService } from '../../products/products.service';

@Injectable()
export class ProductDataResolver {
    private productsService = inject(ProductsService);

    public resolve(route: ActivatedRouteSnapshot): Product {
        const slug = route.paramMap.get('productSlugOrId');
        return this.productsService.getBySlug(slug);
    }
}
